<template>
  <b-card
    tag="b-link"
    :title="item.title"
    :to="item.targetUrl"
    :footer="item.publisher"
    :img-src="fileUrl(this.getImage(item.imageUrl))"
    :img-alt="item.title"
    img-top
    title-tag="h5"
    footer-tag="strong"
    footer-bg-variant="transparent"
    footer-border-variant="transparent"
    class="component-product-card music bg-transparent text-light border-0"
    body-class="text-align-start bg-transparent p-0 mt-3"
    footer-class="d-flex border-0 p-0"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import windowSize from '@/mixins/window-size'

export default {
  name: 'MusicCard',
  mixins: [windowSize],
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isImageLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    })
  },
  methods: {
    getImage (src) {
      var size = this.isMaxWidth480() ? '?w=180' : '?w=250'
      var result = src + size
      return result
    },
    loaded () {
      this.isImageLoaded = true
    }
  }
}
</script>
